// get all
export const FLAG_GETTING_EXPENSE_TYPES = 'FLAG_GETTING_EXPENSE_TYPES';
export const GET_EXPENSE_TYPES = 'GET_EXPENSE_TYPES';
export const CLEAR_EXPENSE_TYPES = 'CLEAR_EXPENSE_TYPES';
